import { FC } from 'react';

import { useAvailableRangesView } from '../context/AvailableRangesViewContext';
import AvailableRangesViewTableSkeleton from './AvailableRangesViewTableSkeleton';
import AvailableRangesViewExpandedTableBody from './AvailableRangesViewExpandedTableBody';

const AvailableRangesViewExpandedTable: FC = () => {
  const { data } = useAvailableRangesView();

  return (
    <table className="table" id="available-ranges-expand-table">
      {data.isLoading ? (
        <AvailableRangesViewTableSkeleton rangesCount={5} />
      ) : (
        <AvailableRangesViewExpandedTableBody />
      )}
    </table>
  );
};

export default AvailableRangesViewExpandedTable;
